import { useEffect, useState } from "react";
import { supabase } from "../../supabaseClient";
import { useParams, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function RegisteredAthletes() {
  const { tryoutId } = useParams();
  const [athletes, setAthletes] = useState([]);
  const [tryout, setTryout] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const loadData = async () => {
      const { data: t } = await supabase.from("tryouts").select("*").eq("id", tryoutId).single();
      setTryout(t);

      const { data: regs } = await supabase
        .from("tryout_registrations")
        .select("*, athlete:athlete_id(full_name, email)")
        .eq("tryout_id", tryoutId);

      setAthletes(regs || []);
      setLoading(false);
    };
    loadData();
  }, [tryoutId]);

  if (loading) return <p className="p-6">Loading…</p>;

  return (
    <div className="p-6 max-w-4xl mx-auto">
      {/* Back Button */}
      <button
        onClick={() => navigate(-1)}
        className="flex items-center gap-2 text-gray-500 hover:text-gray-900 transition-colors mb-6"
      >
        <ArrowLeft size={20} />
        <span>Back</span>
      </button>
      
      <h1 className="text-xl font-bold mb-4">{tryout?.name} Registered Athletes</h1>

      {athletes.length === 0 ? (
        <p className="text-gray-500">No athletes have registered yet.</p>
      ) : (
        <ul className="space-y-2">
          {athletes.map((r) => (
            <li key={r.id} className="p-2 border rounded flex justify-between">
              <div>
                <p className="font-medium">{r.athlete.full_name}</p>
                <p className="text-gray-600 text-sm">{r.athlete.email}</p>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
